import React from 'react';
import '../styles/CompsOverlay.css';
import { House, MapBubble } from '../assets/icons';
import { PropertyCard } from './';

function CompsOverlay(props) {
    const expanded = props.expanded;
    const property = props.property;
    const showScrollableImages = props.showScrollableImages;
    const isLoaded = props.isLoaded;
    const clickedZPID = props.clickedZPID;
    const readOnly = props.readOnly;
    const compsRef = props.compsRef;
    const clickedComp = props.clickedComp;
    const bestComps = props.bestComps;
    const selectedComps = props.selectedComps;
    const loading = props.loading;
    const clickedCompDescription = props.clickedCompDescription;
    const toggleSelectedComp = props.toggleSelectedComp;
    const openDetailedView = props.openDetailedView;
    const onChangeZPIDHover = props.onChangeZPIDHover;
    const innerWidth = props.innerWidth;
    const compTypeLegend = props.compTypeLegend;
    const gptLoading = props.gptLoading;
    const ceilings = props.ceilings;
    const conditionUpdate = props.conditionUpdate;
    return (
        <div className={"comps-overlay-outer-container desktop-none " + (expanded === true ? "comps-overlay-expanded" : "")}>
            <div 
                className="comps-overlay-inner-container"
                ref={compsRef}
            >
                <div className="run-comps-subject-property-section">
                    <PropertyCard
                        property={property}
                        subjectProperty={true}
                        subjectPropertyObject={property}
                        showScrollableImages={showScrollableImages}
                        detail={false}
                        isLoaded={isLoaded}
                        testView={false}
                        alwaysActive={true}
                        selected={false}
                        toggleSelectedComp={null}
                        bestComp={false}
                        openDetailedView={null}
                        clickedZPID={clickedZPID}
                        clickedCompDescription={null}
                        loading={false}
                        onChangeZPIDHover={null}
                        readOnly={readOnly}
                        innerWidth={innerWidth}
                        subjectPropertyHover={false}
                        gptLoading={false}
                        priceCeiling={false}
                        priceCeilingText={null}
                        darkMode={false}
                        conditionUpdate={[]}
                    />
                </div>
                {
                    clickedZPID !== null &&
                    <PropertyCard
                        property={clickedComp}
                        subjectProperty={false}
                        subjectPropertyObject={property}
                        showScrollableImages={showScrollableImages}
                        isLoaded={isLoaded}
                        testView={false}
                        alwaysActive={true}
                        selected={selectedComps.findIndex(e => e.zpid === clickedComp.uniqueIds.zillowId) !== -1 ? true : false}
                        toggleSelectedComp={() => toggleSelectedComp(clickedComp)}
                        bestComp={bestComps.findIndex(e => e.uniqueIds.zillowId === clickedComp.uniqueIds.zillowId) !== -1 ? true : false}
                        openDetailedView={openDetailedView}
                        clickedZPID={clickedZPID}
                        clickedCompDescription={clickedCompDescription}
                        loading={loading}
                        onChangeZPIDHover={null}
                        readOnly={readOnly}
                        innerWidth={innerWidth}
                        subjectPropertyHover={false}
                        gptLoading={gptLoading}
                        priceCeiling={ceilings.findIndex(e => e.zpid === clickedComp.uniqueIds.zillowId) !== -1 ? true : false}
                        priceCeilingText={ceilings.findIndex(e => e.zpid === clickedComp.uniqueIds.zillowId) !== -1 ? ceilings[ceilings.findIndex(e => e.zpid === clickedComp.uniqueIds.zillowId)].description : null}
                        darkMode={false}
                        conditionUpdate={conditionUpdate}
                    />
                }
                {
                    readOnly === false ?
                    bestComps.map((item, index) =>
                        item.uniqueIds.zillowId !== clickedZPID &&
                        <PropertyCard
                            property={item}
                            subjectProperty={false}
                            subjectPropertyObject={property}
                            showScrollableImages={showScrollableImages}
                            isLoaded={isLoaded}
                            key={index}
                            testView={false}
                            alwaysActive={true}
                            selected={selectedComps.findIndex(e => e.zpid === item.uniqueIds.zillowId) !== -1 ? true : false}
                            toggleSelectedComp={() => toggleSelectedComp(item)}
                            bestComp={true}
                            openDetailedView={openDetailedView}
                            clickedZPID={clickedZPID}
                            clickedCompDescription={null}
                            loading={false}
                            onChangeZPIDHover={onChangeZPIDHover}
                            readOnly={readOnly}
                            innerWidth={innerWidth}
                            subjectPropertyHover={false}
                            gptLoading={false}
                            priceCeiling={ceilings.findIndex(e => e.zpid === item.uniqueIds.zillowId) !== -1 ? true : false}
                            priceCeilingText={ceilings.findIndex(e => e.zpid === item.uniqueIds.zillowId) !== -1 ? ceilings[ceilings.findIndex(e => e.zpid === item.uniqueIds.zillowId)].description : null}
                            darkMode={false}
                            conditionUpdate={conditionUpdate}
                        />
                    )
                    :
                    compTypeLegend.map((item, index) =>
                        item.comps.length > 0 &&
                        <React.Fragment 
                            key={index}
                        >
                            <div className="run-comps-best-comps-title-container">
                                <div className="relative-container">
                                    <MapBubble
                                        className=""
                                        fill={item.fill}
                                        stroke={item.stroke}
                                        strokeWidth="0.5"
                                    />
                                    <House
                                        fill={item.house}
                                        className="all-comps-map-house-icon"
                                    />
                                </div>
                                <span className="body-bold colour-primary">
                                    {item.label}
                                </span>
                            </div>
                            {
                                item.comps.map((comp, ii) =>
                                    comp.uniqueIds.zillowId !== clickedZPID &&
                                    <PropertyCard
                                        property={comp}
                                        subjectProperty={false}
                                        subjectPropertyObject={property}
                                        showScrollableImages={showScrollableImages}
                                        isLoaded={isLoaded}
                                        key={ii}
                                        testView={false}
                                        alwaysActive={true}
                                        selected={selectedComps.findIndex(e => e.zpid === comp.uniqueIds.zillowId) !== -1 ? true : false}
                                        toggleSelectedComp={null}
                                        bestComp={true}
                                        openDetailedView={openDetailedView}
                                        clickedZPID={clickedZPID}
                                        clickedCompDescription={null}
                                        loading={false}
                                        onChangeZPIDHover={onChangeZPIDHover}
                                        readOnly={readOnly}
                                        innerWidth={innerWidth}
                                        subjectPropertyHover={false}
                                        gptLoading={false}
                                        priceCeiling={ceilings.findIndex(e => e.zpid === comp.uniqueIds.zillowId) !== -1 ? true : false}
                                        priceCeilingText={ceilings.findIndex(e => e.zpid === comp.uniqueIds.zillowId) !== -1 ? ceilings[ceilings.findIndex(e => e.zpid === comp.uniqueIds.zillowId)].description : null}
                                        darkMode={false}
                                        conditionUpdate={conditionUpdate}
                                    />
                                )
                            }
                        </React.Fragment>
                    )
                }
            </div>
        </div>
    )
};

export default CompsOverlay;